import React, { useCallback, useContext, useState } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import classNames from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication, AUTH_ERRORS } from 'gw-digital-auth-react';
import appConfig from 'app-config';
import AuthMessageComponent from '../AuthMessageComponent/AuthMessageComponent';
import ResetPasswordComponent from '../ResetPasswordComponent/ResetPasswordComponent';
import VerifyPasswordComponent from './VerifyPasswordComponent';
import resetComponentMetadata from '../ResetPasswordComponent/ResetPasswordComponent.metadata.json5';
import metadata from './ChangePasswordComponent.metadata.json5';
import styles from './ChangePasswordComponent.modules.scss';

import messages from '../ResetPasswordComponent/ResetPasswordComponent.messages';
import { isEmpty } from '../LoginUtil';

function checkPasswordValidation(password) {
    const { passwordPolicy } = appConfig;
    const passwordPolicyRegex = new RegExp(passwordPolicy);
    let isValid = true;
    isValid = isValid ? passwordPolicyRegex.test(password) : false;
    return isValid;
}

function ChangePasswordComponent() {
    const auth = useAuthentication();
    const [passwordresetcode, setPasswordresetcode] = useState();
    const [pageView, setPageView] = useState('');
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState('');
    const [pageError, updatePageError] = useState();
    const [changePasswordSuccessful, setChangePasswordSuccessful] = useState(false);
    const { changePassword, authHeader, loginWithoutTwilo } = useAuthentication();

    const handleNewPassword = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }

            if (isEmpty(formData.newPassword) || isEmpty(formData.confirmPassword)) {
                updatePageError(AUTH_ERRORS.fieldEmpty);
                return Promise.resolve();
            }
            if (!_.isEqual(formData.newPassword, formData.confirmPassword)) {
                updatePageError(AUTH_ERRORS.fieldIncorrect);
                return Promise.resolve();
            }

            const isRuleValid = checkPasswordValidation(formData.newPassword);
            if (!isRuleValid) {
                updatePageError(AUTH_ERRORS.passwordRuleError);
                return Promise.resolve();
            }

            const newPasswordObject = {
                new_password: formData.newPassword,
                code: passwordresetcode
            };

            return changePassword(newPasswordObject, authHeader)
                .then(() => {
                    const credentials = {
                        username: auth.user_name,
                        password: formData.newPassword
                    };
                    loginWithoutTwilo(credentials).then(
                        () => {
                            setChangePasswordSuccessful(true);
							updatePageError(AUTH_ERRORS.newPasswordChanged); 
                        }
                    );
                })
                .catch((err) => {
                    switch (err.error) {
                        case AUTH_ERRORS.invalidTokenOrEmail:
                            setPageView(AUTH_ERRORS.invalidTokenOrEmail);
                            break;
                        default:
                            setPageView(AUTH_ERRORS.invalidAttempt);
                            break;
                    }
                });
        },
        [auth.user_name,
            authHeader,
            changePassword,
            formData.confirmPassword,
            formData.newPassword,
            loginWithoutTwilo,
            passwordresetcode]
    );

    const readValue = useCallback(
        (id, path) => {
            return _.get(formData, path);
        },
        [formData]
    );

    const writeValue = useCallback(
        (value, path) => updateFormData({
            ...formData,
            [path]: value
        }),
        [formData]
    );

    const getRules = () => {
        return (
            <ul id="ul">
                <li>
                    {translator(messages.passwordRule1)}
                </li>
                <li>
                    {translator(messages.passwordRule2)}
                </li>
                <li>
                    {translator(messages.passwordRule3)}
                </li>
                <li>
                    {translator(messages.passwordRule4)}
                </li>
                <li>
                    {translator(messages.passwordRule6)}
                </li>
                <li>
                    {translator(messages.passwordRule5)}
                </li>
            </ul>
        );
    };


    const overrideProps = {
        '@field': {
            onValueChange: writeValue
        },
        errorMsg: {
            visible: !_.isUndefined(pageError) && !changePasswordSuccessful,
            message: translator(messages[pageError])
        },
        newPasswordError: {
            visible: true
        },
        newPasswordFieldsContainer: {
            className: 'verifyPasswordContainer',
            visible: !pageView // && !changePasswordSuccessful
        },
        passwordForm: {
            onSubmit: handleNewPassword
        },
        actionsWrapperSingleButton: {
            className: classNames(styles.actionsWrapperSingleButton, styles.coupleButtonStyle)
        },
        changePassword: {
            trigger: handleNewPassword,
            disabled: changePasswordSuccessful
        },
        successfulContainer: {
            visible: false
        },
        invalidTokenError: {
            visible: false
        },
        invalidTokenOrPasswordError: {
            visible: pageView === AUTH_ERRORS.invalidTokenOrEmail
        },
        invalidAttemptError: {
            visible: pageView === AUTH_ERRORS.invalidAttempt
        },
        newUserAccountContainer: {
            visible: false
        },
        passwordRules: {
            content: getRules()
        },
        verifyPasswordViewContainer: {
            visible: _.isUndefined(passwordresetcode) || _.isEmpty(passwordresetcode),
            setPageView: setPageView
        },
        nexusVerifyPasswordComponent: {
            setPasswordresetcode: setPasswordresetcode,
            visible: !changePasswordSuccessful
        },
        successfullyChangedPasswordContainer: {
            visible: changePasswordSuccessful,
            className: 'passwordChangeMessage'
        }, 
        successMsg: {
            visible: !_.isUndefined(pageError) && changePasswordSuccessful,
            message: translator(messages[pageError])
        },
        newPasswordChanged: {
            visible: true
        },
        gwAuthComponent: {
            className: 'changePasswordPageContainer'
        }
    };

    const resolvers = {
        resolveValue: readValue,
        resolveClassNameMap: styles,
        resolveComponentMap: {
            resetPasswordComponent: ResetPasswordComponent,
            verifyPasswordComponent: VerifyPasswordComponent,
            authmessagecomponent: AuthMessageComponent
        }
    };

    if (passwordresetcode || changePasswordSuccessful) {
        return renderContentFromMetadata(
            resetComponentMetadata.componentContent,
            overrideProps,
            resolvers
        );
    }

    return renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );
}

ChangePasswordComponent.propTypes = {
};

ChangePasswordComponent.defaultProps = {
};

export default ChangePasswordComponent;
